var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pdp-overview-container",attrs:{"id":"overview"}},[_c('h3',{staticClass:"pdp-section-header font-weight-bold"},[_vm._v("\n    Overview\n  ")]),_vm._v(" "),_c('div',{ref:"overviewTop"},[_c('ProductsOverviewMedia',{attrs:{"slug":_vm.deal.slug,"media":_vm.deal.overview_media}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }